import React, { useState, useReducer, useContext } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import dayjs from 'dayjs'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { TlsButton } from '../../Settings/Email';

const url = '/process_data/'

export const translate_permissions_keys = {
    'Can': '',
    'add': 'Adicionar',
    'change': 'Alterar',
    'delete': 'Excluir',
    'view': 'Ver'
}

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Processo ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        Object.assign(data, { ...data, ...res.data })
        getData()
        setLoader(false)
        handleClose()
        return
    }
    toast.error(`Processo não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: `)
    setLoader(false)
}


const EditProcessModal = ({ data, handleClose, permissions, reloadData }) => {

    const { setLoader } = useContext(externalComponent)

    const [error, setError] = useState('')

    const [state, setState] = useReducer(lockedReducer, {
        id: data.id ? data.id : 0,
        process: '',
        reu: '',
        autor: '',
        endereco_loja: '',
        cidade: '',
        bairro: '',
        estado: '',
        ...data
    })

    const validData = validateData(state)

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: 'sm' }}
                title={
                    `${getTitle(state)} Processo`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' sx={{ overflow: 'hidden' }}>
                            <Box className='item-profile-row'>
                                <TextField
                                    id="process"
                                    type="text"
                                    label="Processo"
                                    value={state.process}
                                    onChange={(e) => { setState({ 'process': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </Box>
                            <Box className='item-profile-row'>
                                <TextField
                                    id="reu"
                                    type="text"
                                    label="Réu"
                                    value={state.reu}
                                    onChange={(e) => { setState({ 'reu': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 255
                                    }}
                                />
                                <TextField
                                    id="autor"
                                    type="text"
                                    label="Autor"
                                    value={state.autor}
                                    onChange={(e) => { setState({ 'autor': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 255
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1 }} >
                                <TextField
                                    sx={{ flex: 1 }}
                                    id="bairro"
                                    type="text"
                                    label="Bairro"
                                    //disabled={readOnly}
                                    value={state.bairro}
                                    onChange={(e) => { setState({ 'bairro': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 100
                                    }}
                                />

                                <TextField
                                    sx={{ flex: 1 }}
                                    id="cidade"
                                    type="text"
                                    label="Cidade"
                                    //disabled={readOnly}
                                    value={state.cidade}
                                    onChange={(e) => { setState({ 'cidade': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 100
                                    }}
                                />

                                <TextField
                                    sx={{ flex: .2 }}
                                    id="estado"
                                    type="text"
                                    label="UF"
                                    //disabled={readOnly}
                                    value={state.estado}
                                    onChange={(e) => { setState({ 'estado': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 2
                                    }}
                                />
                            </Box>
                            <Box className='item-profile-row textareascroll'>
                                <TextField
                                    label="Endereço da Loja"
                                    multiline
                                    fullWidth={false}
                                    maxRowsrows={4}
                                    size="small"
                                    value={state.endereco_loja}
                                    onChange={(e) => { setState({ 'endereco_loja': e.target.value }) }}
                                    inputProps={{ maxLength: 255 }}
                                />
                            </Box>
                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />
        </>
    )
}

export default EditProcessModal